/**
 * Formats leave days to a maximum of 3 decimal places.
 * Removes trailing zeros for cleaner display.
 *
 * Examples:
 * - 14.40599999999999 -> "14.406"
 * - 17.5 -> "17.5"
 * - 31 -> "31"
 * - 14.100 -> "14.1"
 *
 * @param value - The number of leave days to format
 * @returns Formatted string representation of the leave days
 */
export const formatLeaveDays = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null) return "0";

  // Convert to number if it's a string
  const numValue = typeof value === "string" ? Number.parseFloat(value) : value;

  // Check if conversion was successful
  if (Number.isNaN(numValue)) return "0";

  // If it's a whole number, return as-is
  if (numValue % 1 === 0) {
    return numValue.toString();
  }

  // Round to 3 decimal places
  const formattedValue = numValue.toFixed(3);

  // Remove trailing zeros (but keep at least 1 decimal if .00 at the end)
  if (formattedValue.endsWith("00")) {
    return Number.parseFloat(formattedValue).toFixed(1);
  }

  return formattedValue;
};
